module.exports = __webpack_public_path__ + "media/images/icons/twotone/skin-c3eea021bd365b5aeacda984baf3fa9e.svg";